import { Overlay, Stack, Text, Title } from "@mantine/core";
import "./NoChartDataWrapper.scss";

interface NoChartDataWrapperProps {
  children: React.ReactNode;
  noData: boolean;
  isLoading?: boolean;
}

function NoChartDataWrapper({
  children,
  noData,
  isLoading
}: NoChartDataWrapperProps) {
  if (isLoading) {
    return (
      <div className="NoChartDataWrapper">
        {children}
        <Overlay backgroundOpacity={0}>
          <Stack align="center" h="100%" justify="center">
            <Title order={5}>Daten werden geladen...</Title>
          </Stack>
        </Overlay>
      </div>
    );
  }

  return (
    <div className="NoChartDataWrapper">
      {children}
      {noData && (
        <Overlay backgroundOpacity={0}>
          <Stack align="center" h="100%" justify="center">
            <Title c="dimmed" order={5}>
              Leider konnten wir für Ihre aktuelle Auswahl keine Daten finden.
            </Title>
            <Text c="dimmed">Bitte treffen Sie eine andere Filterauswahl.</Text>
          </Stack>
        </Overlay>
      )}
    </div>
  );
}

export { NoChartDataWrapper, NoChartDataWrapperProps };
